import React from "react";
import classnames from "classnames";

import "./Layout.css";

export const Page = ({ children }) => (
  <div className="page">
    {children}
  </div>
);

export const PageContent = ({ children }) => (
  <div className="pageContent">
    {children}
  </div>
);

export const Section = ({ children, id }) => (
  <section className="section" id={id}>
    {children}
  </section>
);

const sizeToClassName = (space = "", size = "") => {
  return space.toUpperCase().split("-").map(function(space) {
    return size + space;
  });
};

export const SectionContent = ({ children, xs, s, m, l, xl, xxl, bleed }) => {
  const className = classnames([
    "sectionContent",
    bleed ? "sectionContent--bleed" : null,
    xs ? sizeToClassName(xs, "xs") : null,
    s ? sizeToClassName(s, "s") : null,
    m ? sizeToClassName(m, "m") : null,
    l ? sizeToClassName(l, "l") : null,
    xl ? sizeToClassName(xl, "xl") : null
  ]);

  return (
    <div className={className}>
      {children}
    </div>
  );
};

export const SectionContentHeader = ({ children }) => (
  <div className="sectionContentHeader">
    {children}
  </div>
);

export const SectionRow = ({ children, xs, s, m, l, xl, xxl, reverse }) => {
  const className = classnames([
    "sectionRow",
    reverse ? "sectionRow--reverse" : null,
    xs ? sizeToClassName(xs, "xs") : null,
    s ? sizeToClassName(s, "s") : null,
    m ? sizeToClassName(m, "m") : null,
    l ? sizeToClassName(l, "l") : null,
    xl ? sizeToClassName(xl, "xl") : null
  ]);
  return (
    <div className={className}>
      {children}
    </div>
  );
};

export const SectionColumn = ({ children }) => (
  <div className="sectionColumn">
    {children}
  </div>
);



// WEBPACK FOOTER //
// ./src/components/Layout.js